export default class Util {
    static startLoading(element) {
        if (typeof element === 'undefined' || !element)
            return;

        element.classList.add("btn-loading");
        element.disabled = true;
        const loader = document.createElement('div');
        loader.classList.add("loader");
        const spinner = document.createElement('div')
        spinner.classList.add("spinner-border");
        loader.appendChild(spinner);
        element.appendChild(loader);
    }

    static stopLoading(element) {
        if (typeof element === 'undefined' || !element)
            return;

        const loader = element.querySelector(".loader")
        loader.remove();
        element.disabled = false;
        element.classList.remove("btn-loading");
    }

    static parseTemplate(template) {
        return document.createRange().createContextualFragment(template);
    }

    static parseJSONDate(value) {
        if (typeof value === 'string') {
            var d = /\/Date\((\d*)\)\//.exec(value);
            return (d) ? new Date(+d[1]) : value;
        }
        return value;
    }

    static toNodeList(element) {
        let wrp = document.createElement("div");
        wrp.appendChild(element);

        return wrp.childNodes;
    }
}